exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.showIconFirst {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\n}\n.showIconFirst .v-icon {\r\n  order: 1;\r\n  margin-right: 4px;\r\n  position: static;\n}\n.showIconFirst .sb_label {\r\n  order: 0;\n}\n.showIconFirst span:not(.sb_label) {\r\n  order: 2;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\n}\r\n", ""]);

// exports
